import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

export const getFetch = (url : string) => {

    return new Promise(async (resolve, reject) => {

        var token : any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }
    
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
    
        //서버가 응답 못하는 상황(과부하 등) 대비 타임아웃 30초
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        fetch(`https://peetsunbae.com${url}`, {
            method : "GET",
            headers : {
                "Authorization" : token
            },
            credentials : "include",
            signal : controller.signal
        }).then((response : any) => {
            clearTimeout(timeoutId);
            //상태코드는 검사하지 않는다 — 이 서버는 에러도 500 + JSON body({message:...})로 주는 관례라
            //기존처럼 body를 그대로 전달해야 호출부의 result.message 분기(에러 토스트/롤백)가 동작한다
            response.json()
            .then((result : any) => {
                resolve(result);
            })
            .catch((e : Error) => {
                //json 파싱 실패(nginx 502 HTML, 빈 응답 등) 시에도 reject — 기존에는 Promise가 영원히 pending되어
                //로딩이 안 풀리고 사용자가 새로고침을 반복하며 요청 폭풍을 키우던 버그
                reject(e);
            })
        }).catch((e : Error) => {

            clearTimeout(timeoutId);
            reject(e);
        })

    })
}

export const postFetch = (url : string, body : {}) => {

    return new Promise(async (resolve, reject) => {

        var token : any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }
    
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
    
        //서버가 응답 못하는 상황(과부하 등) 대비 타임아웃 30초
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 30000);

        fetch(`https://peetsunbae.com${url}`, {
            method : "post",
            headers : {
                "Authorization" : token,
                "content-type" : "application/json"
            },
            credentials : "include",
            body : JSON.stringify(body),
            signal : controller.signal
        }).then((response : any) => {
            clearTimeout(timeoutId);
            //상태코드는 검사하지 않는다 — 에러도 500 + JSON body 관례라 body를 그대로 전달
            response.json()
            .then((result : any) => {
                resolve(result);
            })
            .catch((e : Error) => {
                //json 파싱 실패 시에도 reject (영구 pending 방지)
                reject(e);
            })
        }).catch((e : Error) => {

            clearTimeout(timeoutId);
            reject(e);
        })

    })

}

export const postFetchFormData = (url : string, body : FormData) => {

    return new Promise(async (resolve, reject) => {

        var token : any = "";

        if (Capacitor.isNativePlatform()) {
            const { value } = await Preferences.get({ key: "token" });
            token = value;
        }
    
        if (window.electron) {
            token = await window.electron.sendMessageApi.getToken();
        }
    
        //파일 업로드는 느린 회선 고려해서 타임아웃 120초
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 120000);

        fetch(`https://peetsunbae.com${url}`, {
            method : "post",
            headers : {
                "Authorization" : token,
            },
            credentials : "include",
            body : body,
            signal : controller.signal
        }).then((response : any) => {
            clearTimeout(timeoutId);
            //상태코드는 검사하지 않는다 — 에러도 500 + JSON body 관례라 body를 그대로 전달
            response.json()
            .then((result : any) => {
                resolve(result);
            })
            .catch((e : Error) => {
                //json 파싱 실패 시에도 reject (영구 pending 방지)
                reject(e);
            })
        }).catch((e : Error) => {

            clearTimeout(timeoutId);
            reject(e);
        })

    })

}